import React from 'react';
import SupabaseTest from '../components/SupabaseTest';

const TestPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SupabaseTest />
    </div>
  );
};

export default TestPage;